import { render, staticRenderFns } from "./CheckboxPC.vue?vue&type=template&id=25e39207&scoped=true"
import script from "./CheckboxPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CheckboxPC.vue?vue&type=style&index=0&id=25e39207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e39207",
  null
  
)

export default component.exports